import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import cx from 'classnames';
import { alpha } from '@classify/react-core-components/styles';

import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(({ palette, typography, spacing, shape, breakpoints }) => {
  const lineColor = alpha(palette.layout.line.divider, 0.6);

  return {
    root: {
      position: 'relative',
      width: '100%',
      display: 'grid',
      textDecoration: 'none',
      gridTemplateColumns: 'min-content 1fr min-content',
      alignItems: 'stretch',
      '& > *': {
        display: 'flex',
        alignItems: 'center',
      },
    },
    decoration: {
      position: 'relative',
      borderTopLeftRadius: shape.borderRadius,
      borderBottomLeftRadius: shape.borderRadius,
    },
    content: {
      border: `1px solid ${lineColor}`,
      borderTopLeftRadius: shape.borderRadius,
      borderBottomLeftRadius: shape.borderRadius,
      borderRight: 'none',
      flexGrow: '1',
      padding: spacing(1, 2),
      ...typography.subtitle1,
    },
    iconContainer: {
      border: `1px solid ${lineColor}`,
      borderLeft: 'none',
      borderTopRightRadius: shape.borderRadius,
      borderBottomRightRadius: shape.borderRadius,
      paddingRight: spacing(1),
    },
    icon: {
      fontSize: '1.7rem',
      color: palette.text.secondary,
    },

    isColorDimmed: {
      '& $decoration': {
        '&::before': {
          background: ['rgba(255, 255, 255, .93)', '!important'],
        },
      },
    },

    hasDecoration: {
      '& $content': {
        borderLeft: 'none',
      },
      '& $decoration': {
        minWidth: 8,
        background: 'var(--color)',
        '& > *': {
          zIndex: 1,
          position: 'relative',
        },
        '&::before': {
          content: '" "',
          position: 'absolute',
          top: 0,
          right: 0,
          left: 0,
          bottom: 0,
          background: 'rgba(255, 255, 255, .68)',
        },
      },
    },

    [breakpoints.up('sm')]: {
      decoration: {
        '& > *': {
          display: 'block',
        },
      },
    },
  };
});

export default function CardLink({
  children,
  color = 'transparent',
  component: Component = 'a',
  decoration = null,
  isColorDimmed = false,
  ariaLabel = 'Go to',
  ...otherProps
}) {
  const classes = useStyles();

  return (
    <Component
      {...otherProps}
      className={cx(classes.root, {
        [classes.isColorDimmed]: isColorDimmed,
        [classes.hasDecoration]: decoration,
      })}
      style={{ '--color': color }}
    >
      <div className={classes.decoration}>{decoration}</div>
      <div className={classes.content}>{children}</div>
      <div className={classes.iconContainer}>
        <ChevronRightIcon className={classes.icon} aria-label={ariaLabel} />
      </div>
    </Component>
  );
}
